module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("HOOFDSTUK EEN")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "page-break-before": "always",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("N")]), _vm._v("iemand had mevrouw")]), _vm._v(" Bleasdale ooit zien lopen, zelfs niet tijdens haar jaren als schoolhoofd op de lokale basisschool. Het was dus een verrassing om de oudere vrouw te zien galopperen langs de hoofdstraat van Little Changeling. Ze ging zo snel, dat ze bijna een paar jonge moeders omver kegelde die hun kinderwagen langs het postkantoor duwden.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Sorry,’ riep ze, met weinig meer dan een korte blik over haar schouder. Met evenveel aandacht op de weg, stak ze de stille straat over en barstte door de deur van de lokale krantenboer, met een kleine hartaanval als gevolg voor de drie mensen binnen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Wat is er in hemelsnaam aan de hand, Audrey?’ riep Maurice uit van achter zijn toonbank, terwijl hij toekeek hoe mevrouw Bleasdale op adem kwam tegen de vitrine met drankjes. ‘Bang dat de nieuwe kraslotjes op zouden zijn of zo?’ lachte hij.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Zijn vrouw, Meryl, zat vlakbij op een kruk en bracht een laag teef-rode nagellak aan op haar klauwen.Ze gaf de oudere dame een snelle blik. ‘Nee, Mevrouw Bleasdale vindt gokken een zonde, niet schat?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Niet echt,’ Antwoordde mevrouw Bleasdale tussen diepe slokken lucht in. Ze wierp een minachtende blik terug op haar ex-leerling. 'Ik zei dat het tijdverspilling was.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Moet je even zitten?’ vroeg de jongeman die zijn dagelijkse krant kwam halen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Goed idee,’ ging Maurice mee, terwijl hij van achter de toonbank kwam. ‘Alfie, help me Audrey even neerzetten.’ He keek even naar zijn vrouw. ‘Meryl, sta even recht, zodat deze arme dame kan rusten.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mevrouw Bleasdale wuifde hem weg. ‘Nee nee. Bedankt, maar ik ben in orde. Echt. Ik ben niet gewend aan het rennen, dat is alles.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Gerustgesteld, leunde Maurice tegen de voorzijde van de toonbank en vouwde hij zijn armen over elkaar. ‘Wat heeft je nu zo van streek gebracht, Audrey?’ vroeg hij.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Ze kan niet bij je wegblijven, Maurice,’ plaagde Alf, terwijl hij zijn krant oprolde en onder zijn arm stak.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Meryl, die nog geen centimeter van de stoel bewogen was, zelfs wanneer het gevraagd werd, gaf een korte ‘Ha!’ bij dat idee en lakte haar nagels verder af.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Het gaat over het huis,’ begon de oudere vrouw.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Jouw huis?’ kwam Alf als echo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Nee. Nee, natuurlijk niet mijn huis. Alsjeblieft zeg, hoe lang woon je al in Little Changeling? Ik bedoel, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("het ")]), _vm._v("huis.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dit deed bij Meryl de oren spitsen. Ze zette de pot nagellak op de toonbank en keek op. ‘Is het gekocht?’ Met haar vraag beantwoord door een knik van mevrouw Bleasdale, trok Meryl haar vers geplukte wenkbrauwen op. ‘Het duur al zo lang dat ik dacht dat het voor altijd verlaten zou blijven.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Mijn zus, Enid, belde me net,’ ging mevrouw Bleasdale verder.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Heeft je zus het gekocht?’ vroeg Alf.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Nee!’ antwoordde ze, met een geïrriteerde kant aan haar stem. ‘Haar buurman, Derek, is een makelaar in de stad. Een man ging gisteren bij hem binnen, zag het huis in hun boeken en kocht het meteen, ter plekke!’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘God, moet wel een of andere gek zijn,’ zei Maurice.‘")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Ik weet het,’ ging mevrouw Bleasdale akkoord. ‘Volgens Enid - wel, Derek, eigenlijk- komt de man morgen het huis bekijken!’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘We moeten hem waarschuwen,’ ging Maurice verder. ‘Hem laten weten waar hij aan begint.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Maar dan moet er iemand echt in de buurt van het huis komen. In "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("haar ")]), _vm._v("buurt,’ zei Meryl, De laatste zin bijna venijnig gespuwd.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Hé, komaan, lief. Dat is nergens voor nodig. Het arme ding kan er niet aan doen,’ zei Maurice diplomatisch.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Ik wil wedden van wel,’ beet Meryl terug. ‘Ik wil wedden dat ze het geweldig vindt, onschuldige mensen zo kwaad berokkenen.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Alf keek het koppel een moment aan. ‘Deze kerel zou wel eens anders kunnen zijn. Misschien is hij wel immuun aan haar.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("'Dat moet wel, om daar te wonen,' mompelde Meryl. Ze sprak mevrouw Bleasdale opnieuw aan. 'Weten we de naam van deze man?'")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘ Die heeft Enid niet verteld,’ kwam het antwoord.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Dus... Waarschuwen we hem of niet?’ bracht Maurice op.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Dat is de moeite toch niet?’ snoof Meryl. ‘De anderen luisterden geen van allemaal en kijk wat er met hen gebeurde.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("De deur zwaaide open en een indrukwekkende zwarte labrador sprong naar binnen, waardoor onmiddellijk chaos heerste. De hond duwde mevrouw Bleasdale bijna omver, terwijl hij door de winkel stuiterde.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Hey!’ krijste Meryl, kijkend hoe het schepsel pauzeerde om aan een stapel kranten te snuiven die nog door een touwtje gebonden was. ‘Maurice, doe iets aan dat mormel!’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Oh Rupert, gedraag je alsjeblieft,’ kwam een vermoeide stem uit de deuropening. Een lange, verweerde man stond in de winkel en droeg het onmiskenbare aroma van een boer. De labrador vloog terug naar zijn meester en sprong omhoog, maar de man liep hem voorbij, naar de toonbank.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Goeiemorgen, Graham,’ zei Meryl, met een valse glimlach aan haar gezicht gelijmd. 'Zeg niet dat je je kranten nooit hebt ontvangen? Ik herinner me dat ik ze in de tas van de krantenjongen stak voordat hij vertrok.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Oh, nee, die heb ik, dank je.’ antwoordde Graham. ‘Ik zag Audrey de straat door rennen en vroeg me af of er iets mis was.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Mevrouw Bleasdale bloosde ervan.Het was geen geheim voor de dorpelingen dat ze een boon had voor de welbespraakte boer. ‘Oh, dat is heel vriendelijk van je, Graham. Alles is helemaal goed met me,’ zei ze. ‘Ik vertelde iedereen gewoon dat iemand het huis gekocht heeft.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Echt?’ zei Graham, terwijl hij naar adem hapte. ‘Hoe buitengewoon. Wie?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Een man uit de stad’ viel Maurice bij. ‘Meer weten we niet.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘En weet hij van...?’ Graham’s stem viel weg.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Dat denk ik niet,’ vertelde Meryl. ‘Maar blijkbaar komt hij morgen langs om een kijkje te nemen. Kan je geloven dat hij het kocht zonder de binnenkant te zien?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Goh. Nou, ik wens hem veel succes, uiteraard,’ zei Graham. ‘Rupert, stop daarmee!’ Hij klapte scherp op zijn been. De hond deed zijn been weer naar beneden aan de hoek van de drankkast en trippelde naar de boer. ‘Ik moet met hem naar buiten.’ Hij nam Rupert’s leiband in de hand. ‘Wel, blij dat alles in orde is. Een goede dag voor jullie allemaal.’ ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("De boer had de deur niet eens goed en wel achter hem dicht getrokken voordat andere dorpelingen binnen stroomde, vragend of mevrouw Bleasdale wel in orde was. Het nieuws dat iemand het huis naast de heks had gekocht, verspreidde zich vrijwel onmiddellijk door het dorp, en die avond in de kroeg was het het meest besproken onderwerp.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-h"
  }, [_vm._v("H")]), _vm._v("enny Wilson stond")]), _vm._v(" voor het keukenraam, luisterend naar het geluid van de regen die tegen het raam hamerde, terwijl haar reflectie haar aanstaarde. 'Weet je, er zou iemand net buiten kunnen staan en naar binnen kijken en ik er niets van merken,’ zei ze met een zware zucht.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("'Zoals dat schorriemorrie dat je professor Anderling noemt?’ klonk een geaffecteerde stem. ‘Doe het licht aan en kijk maar.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny glimlachte. ‘Nee, het is ok... Ik probeerde een gesprek te beginnen.’ Ze kwam terug naar de tafel en ging zitten.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("De raap die op tafel zat verschoof zich tot het haar aankeek. ‘Wat scheelt er?’ vroeg die. ‘Oh, Ik weet het al. Je bent eenzaam.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Ben ik niet.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Dat ben je wel. Je doet steeds zo wanneer je eenzaam bent. Wat steeds vaker voorvalt trouwens.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny sloeg haar armen over elkaar en leunde naar achteren. ‘En waarom zou ik eenzaam zijn als ik met jou kan praten?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Oh, je gaat me niet vertellen dat je liever je tijd doorbrengt met een pratende wortelgroente dan met echte mensen, jongedame.'")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ze keek voorbij dan Tip's uitgehouwen ogen naar de gloeiende kaars binnenin. De vlam die hem tot leven had gebracht flikkerde in de tocht van de kamer. ‘Ik zou ze alleen maar kwetsen’ zei ze met een finale noot in haar stem.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Het is te vroeg op de avond om sentimenteel te worden. Doe op z'n minst eerst een fles wijn open.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Je kan niet drinken,’ zei Henny onbewogen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Weet ik,’ kaatste Tip terug. ‘Maar je bent grappig als je tipsy bent.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny gaf een vermoeide glimlach en geeuwde. ‘Er vroeg in, denk ik,’ besliste ze, terwijl ze rechtstond")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Kijk uit voor het... schap,’ riep Tip uit, net iets te laat. Henny had haar hoofd al tegen het boekenschap boven haar gestompt. ‘Gaat het?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ja,’ zei ze met een vertrokken gezicht. Dat was de zevende keer deze week dat ze haar hoofd gestoten had. Ze was vooral verrast dat haar schedel nog heel was. ‘Wil je dat ik je nu al doof?’ vroeg ze terwijl ze over haar hoofd wreef.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Euhm.... nog niet, denk ik. Ik ben nog niet echt moe.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny tuitte haar lippen en staarde haar onwaarschijnlijke vriend. ‘Met andere woorden, ik ben de hele nacht wakker, luisterend naar je geklets?’ plaagde ze.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Nou, ik ben nooit zo beledigd geweest in mijn leven ... of mijn dood,’ slaakte Tip uit.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny lachte. ‘Jawel hoor.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("De opening die als Tip’s mond dienst deed, vervormde zich naar een ongelijke glimlach. ‘Zo. Ik wist dat ik je kon opvrolijken.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Wat zou ik zonder je doen?’ zei ze, terwijl haar ogen de kamer afspeurden. Nu, waar is die kat naartoe?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Oh, die zal ongetwijfeld van het lokale nachtleven proeven met vreugde en zorgeloosheid,’ zei Tip, met een giftige toon. ‘Gelukzak.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Wel, hij mag het hebben. Komaan, bedtijd’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tegen de tijd dat Henny Tip op het nachtkastje had gezet, haar pyjama aan had gedaan en haar tanden had gepoetst, had ze had twee kleine ongevallen gehad. Het eerste was een teenstoot-incident waar haar rechtervoet en een van de poten van het bed bij betrokken waren. Het tweede betrok een vlekje tandpasta dat haar in het oog raakte terwijl ze haar tanden poetste. Als gevolg ging Henny nog slechter gezind dan voorheen in bed liggen. Ze sloeg de lichtschakelaar over. Met de veiligheid van de gloed van Tip's kaars, kroop ze in bed, de enige plaats waar ze nooit een ongeluk had gehad.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Met het risico dat ik klink als een t-shirt... Is alles ok?’  vroeg Tip.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Ja,’ antwoordde ze met een doffe stem. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Ik zou helpen als ik kon.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Langzaam Henny trok het dekbed van over haar hoofd terug en keek hem aan. ‘Ik weet het. Dank je,’ zei ze warm.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tip geeuwde. ‘Het lijkt er op dat ik toch moe ben,’ zei hij. ‘Aan jou de eer?’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Natuurlijk. Slaap wel.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Droom zacht.’")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny leunde naar voren en blies de vlam uit. Terwijl de rook in een spiraal de lucht in steeg, lag ze terug in haar bed. Ze had alle boeken doorzocht die haar voorouders hadden nagelaten, maar Henny kon er geen bezwering vinden om de ziel van Tip te verplaatsen naar iets minder opvallend. Het was maar goed dat de gemeenschap haar de rug toekeerde. Als haar ooit haar zagen praten met een grote raap met uitgehouwen ogen en mond ...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ze staarde naar de streep maanlicht die over het plafond liep van tussen de gesloten gordijnen. Ze was niet moe. Niet echt. Maar als je zo gevoelig bent aan ongevallen dat je de televisie niet durfde aan te zetten of zelfs maar een boek te lezen, was er niet veel meer te doen dan slapen of...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Henny klikte het lampje op haar nachtkast aan en kwam uit bed. Er was, naast slapen, maar een ding waarbij de vloek haar met rust liet. Ze begreep de redenering erachter niet, maar ze ging er niet over klagen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ze stond zich de zwarte outfit nog maar aan te passen, of ze voelde het onzichtbare gewicht van de vloek al van zich heffen en plaatsmaken voor het gevoel van rust dat neerdaalde. Ze stond voor de lange spiegel in de hoek van de kamer en deed haar staart los. Haar lange haren vielen langs haar schouders, een perfect omlijsting van haar gezicht. Het laatste item op de lijst van heksachtige kleding was natuurlijk de donkere puntige hoed, die ze in een lange schoendoos bewaarde. Daar waren ooit de laarzen in aangekomen. Het deksel werd er van gehaald, ze tilde de hoed er met eerbied uit en zette die stevig op haar hoofd. Haar weerspiegeling gaf haar een tevreden knipoog.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Heel sexy,’ zei die. ‘Al ben je nog een ding vergeten.’ Henny keek toe hoe de weerspiegeling voorspelbaar de bovenste twee knoppen van haar rode hemd open deed en zo haar decolleté onthulde. Ze deed niet eens de moeite om naar beneden te kijken. Wat haar evenbeeld in de spiegel ook deed, hetzelfde zou in de echte wereld ook gebeuren. Ze liep door naar de gang en en voelde de bekende tinteling die haar vertelde dat er het komende uur geen ongelukken zouden gebeuren")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-d"
  }, [_vm._v("D")]), _vm._v("e bezem was zuiver")]), _vm._v(", onaangetast door de runes en pentagrammen waarvoor andere jonge heksen een voorliefde voor hadden, en stond tegen de muur net bij de voordeur. Terwijl ze er naar toe ging, stootte de bezem van de muur af, rechtop en ongeduldig naar de greep van zijn minnares.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("De koele zomerlucht plaagde Henny's gezicht wanneer ze het huis verliet. Toen ze langs het lege gebouw naast het hare kwam, keek ze kort naar de voorgevel naar tekens van vandalisme. Enkele van de verveelde tieners in het dorp hadden er plezier in gevonden om graffiti te spuiten of er in de weekenden hun afval te laten liggen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Een groepje van hen had ooit geprobeerd om het huis van Henny in te sluipen toen ze dachten dat ze er niet was. Ze had toen in bad gezeten en had het bekende gekraak van de voordeur gehoord toen die open ging. Zelfs toen ze het luide gefluister en gegiechel hoorde, kwam ze haar bad niet uit. Ondanks de talloze ongevallen die Henny er de hele tijd had, speelde het huis als voor waakhond als het om indringers ging. Ze had nooit ontdekt wat de tieners was overkomen terwijl zij in de badkamer zat. Na het gegil en haastig terugtrekkende stappen had niemand ooit weer geprobeerd het huis in te komen")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Er was geen graffiti. Ze merkte wel op dat het oude, beschadigde \"Te Koop\"-bord op het onverzorgde gazon lag. De makelaars hadden de verkoop eindelijk echt opgegeven. Henny was niet verbaasd. Waarom zou je zelfs een bord zetten? Niemand bleef meer dan een paar maanden. Bij gelegenheid, toen de ongelukken op hun pijnlijkst waren, vroeg Henny zich af of, als ze in het lege huis zou gaan wonen, de ongelukken dan zouden stoppen. Maar het was niet haar huis dat vervloekt was. Het was zij zelf.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Bezem in de hand wandelde ze de weg naar het veld aan de achterkant van de huizen af. De maan was vol en helder en toonde een klein schepsel dat op haar af wandelde.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Een goede nacht gehad?’ vroeg ze het diertje. De kat was een paar meter van haar af gestopt. Zijn ogen schitterden en het beestje ronkte. Henny lachte. ‘Zo leuk, dan? Ga je graag met me mee, of ga je terug?’ De kat zat op zijn hurken en likte zijn poten. ‘Dank je,’ zei Henny. ‘Weet je, ik wou dat ik kon verstaan wat je zegt. Begrijp me niet verkeerd, Tip is leuk om in de buurt te hebben, maar het zou leuk zijn om iemand anders te spreken. Of misschien "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kan ")]), _vm._v("je met me praten, maar doe je maar alsof je het niet kan. Dat is omdat ik je Fluffy noemde, niet?’ De voornoemde Fluffy koos dat moment om om te keren en te wachten met zijn rug naar haar. Henny lachte voor zichzelf en ging verder, met Fluffy die naast haar trippelde.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Het veld waar ze gewoonlijk van vertrok, bewoond door ongeveer een dozijn koeien, was het eigendom van Graham Plum, de boer die veel van het land rondom het dorp bezat. Graham was zich ervan bewust dat ze het gebruikte, maar deed niets om haar te stoppen. Henny vond dat hij een van de liefste was. Als ze een wandeling door het veld maakte en Graham er was, zou hij steeds hallo zeggen - maar zijn afstand houden - in tegenstelling tot de meeste andere dorpelingen. Meer dan eens had ze wat melk of jam gevonden die bij haar deur stond, door onbekende personen daar achtergelaten. Er was geen briefje bij, maar Henny had het gevoel dat de gemoedelijke boer er achter zat.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Er was een grote ruimte in het midden van het veld om van op te stijgen - de koeien hadden er voor gekozen om meer bij de stenen muren rondom het land te slapen. Henny kwam tot stilstand en sloeg de bezem tussen haar benen. Ongeacht de talloze malen dat ze dat had gedaan, voelde ze zich altijd een beetje gek als ze op de lange bezemsteel ging zitten. Met zorg om niet te ver naar achter te zitten, maakte ze genoeg ruimte voor haar metgezel. Fluffy lanceerde zichzelf naar het bovenste deel van de bezem, met het perfecte evenwicht dat alleen een kat heeft.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("‘Hou je vast aan je kont, Fluffy,’ mompelde Henny, klaar om te vertrekken.Ze zette een beetje meer gewicht op de bezem, die als een soort springplank optrad. Een paar seconden later scheerde zowel heks als kat opwaarts naar de wolkeloze, inkt-kleurige lucht.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Met haar handen stevig op de steel, Kon Henny een luid gejoel niet onderdrukken. Het was zo bevrijdend om in de lucht te zijn, verbaasde uilen en andere nachtvogels voorbij te steken. En vooral, het was zo leuk om te weten dat er niet een ongeluk zou gebeuren tijdens haar stint in de lucht. Terwijl ze zich naar de verbrand oranje lichten van het dorp begaf, vroeg Henny zich af of het mogelijk was de rest van haar dagen op haar bezem door te brengen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0